module.exports = __webpack_public_path__ + "img/Katarina_outside_5.631c2a95.jpg";